import { render, staticRenderFns } from "./LookStudentProfile.vue?vue&type=template&id=ee2c1b24"
import script from "../../services/teacher/look-student-profile.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/look-student-profile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports